;(function () {
  var root = document.getElementById('lev-expertxp');
  if (!root) return;

  var FORM_AVAILABLE = root.getAttribute('data-form-available') === 'true';
  var CUPOM = root.getAttribute('data-cupom') || '';
  var WEBHOOK = root.getAttribute('data-webhook') || '';
  var section = document.getElementById('lev-expertxp-form-section');
  var panel = root.querySelector('[data-expertxp-panel]');
  var form = root.querySelector('[data-expertxp-form]');
  var success = root.querySelector('[data-expertxp-success]');
  var wavesDefault = root.querySelector('[data-expertxp-waves-default]');
  var wavesSubmitted = root.querySelector('[data-expertxp-waves-submitted]');
  var addressInfo = root.querySelector('[data-expertxp-address]');
  var addressFields = root.querySelector('[data-expertxp-address-fields]');
  var cpfInvalid = root.querySelector('[data-expertxp-cpf-invalid]');
  var submitError = root.querySelector('[data-expertxp-submit-error]');
  var submitButton = root.querySelector('[data-expertxp-submit]');
  var submitLabel = root.querySelector('[data-expertxp-submit-label]');
  var privacyFace = root.querySelector('[data-expertxp-privacy-face]');
  var cepFound = false;
  var cepTimer = null;
  var submitting = false;

  function digits(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function maskCpf(value) {
    return digits(value)
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2')
      .slice(0, 14);
  }

  function maskPhone(value) {
    return digits(value)
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{1})(\d{4})(\d)/, '$1 $2-$3')
      .replace(/(-\d{4})\d+?$/, '$1');
  }

  function maskCep(value) {
    return digits(value)
      .replace(/(\d{5})(\d)/, '$1-$2')
      .replace(/(-\d{3})\d+?$/, '$1');
  }

  function isValidCpf(value) {
    var cpf = digits(value);
    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;
    var sum = 0;
    var i;
    for (i = 0; i < 9; i += 1) sum += Number(cpf.charAt(i)) * (10 - i);
    var check = (sum * 10) % 11;
    if (check === 10) check = 0;
    if (check !== Number(cpf.charAt(9))) return false;
    sum = 0;
    for (i = 0; i < 10; i += 1) sum += Number(cpf.charAt(i)) * (11 - i);
    check = (sum * 10) % 11;
    if (check === 10) check = 0;
    return check === Number(cpf.charAt(10));
  }

  function field(name) {
    return form.querySelector('[name="' + name + '"]');
  }

  function values() {
    return {
      nome: field('nome').value,
      cpf: field('cpf').value,
      whatsapp: field('whatsapp').value,
      email: field('email').value,
      cep: field('cep').value,
      endereco: field('endereco').value,
      cidade: field('cidade').value,
      estado: field('estado').value,
      numero: field('numero').value,
      complemento: field('complemento').value,
    };
  }

  function formValid() {
    var data = values();
    return Boolean(
      data.nome.trim() &&
        isValidCpf(data.cpf) &&
        digits(data.whatsapp).length === 11 &&
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email.trim()) &&
        digits(data.cep).length === 8 &&
        cepFound &&
        data.numero.trim() &&
        field('privacy').checked
    );
  }

  function refreshSubmit() {
    var valid = formValid();
    var ready = FORM_AVAILABLE && valid && !submitting;
    submitButton.disabled = !ready;
    submitButton.classList.toggle('is-valid', ready);
  }

  function refreshCpf() {
    var cpf = field('cpf').value;
    var invalid = digits(cpf).length === 11 && !isValidCpf(cpf);
    cpfInvalid.hidden = !invalid;
    field('cpf').setAttribute('aria-invalid', invalid ? 'true' : 'false');
  }

  function clearAddress() {
    cepFound = false;
    field('endereco').value = '';
    field('cidade').value = '';
    field('estado').value = '';
  }

  function renderAddress(state) {
    if (state === 'hidden') {
      addressInfo.hidden = true;
      addressFields.hidden = true;
      return;
    }
    addressInfo.hidden = false;
    if (state === 'loading') {
      addressInfo.textContent = 'Buscando endereço...';
      addressFields.hidden = true;
      return;
    }
    if (state === 'missing') {
      addressInfo.textContent = 'CEP não encontrado. Ajuste o CEP para continuar.';
      addressFields.hidden = true;
      return;
    }
    addressInfo.replaceChildren();
    [
      field('endereco').value || '(Logradouro não vinculado a este CEP — conferir na hora da compra)',
      field('cidade').value,
      field('estado').value,
    ].forEach(function (line) {
      var span = document.createElement('span');
      span.textContent = line;
      addressInfo.appendChild(span);
    });
    addressFields.hidden = false;
  }

  function lookupCep() {
    var cep = digits(field('cep').value);
    if (cep.length !== 8) {
      clearAddress();
      renderAddress('hidden');
      refreshSubmit();
      return;
    }
    renderAddress('loading');
    fetch('https://viacep.com.br/ws/' + cep + '/json/')
      .then(function (response) {
        return response.json();
      })
      .then(function (body) {
        if (digits(field('cep').value) !== cep) return;
        if (!body || body.erro) {
          clearAddress();
          renderAddress('missing');
        } else {
          cepFound = true;
          field('endereco').value = body.logradouro || '';
          field('cidade').value = body.localidade || '';
          field('estado').value = body.uf || '';
          renderAddress('found');
        }
        refreshSubmit();
      })
      .catch(function () {
        if (digits(field('cep').value) !== cep) return;
        clearAddress();
        renderAddress('missing');
        refreshSubmit();
      });
  }

  function showError(message) {
    submitError.hidden = false;
    submitError.textContent = message;
  }

  function showSuccess() {
    section.classList.add('is-submitted');
    panel.hidden = true;
    success.hidden = false;
    wavesDefault.hidden = true;
    wavesSubmitted.hidden = false;
  }

  function scrollToSuccess() {
    if (window.matchMedia('(max-width: 1064px)').matches) {
      success.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    } else {
      section.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

  function readJson(response) {
    return response.text().then(function (text) {
      if (!text) return null;
      try {
        return JSON.parse(text);
      } catch (error) {
        return null;
      }
    });
  }

  root.querySelectorAll('[data-expertxp-scroll]').forEach(function (button) {
    button.addEventListener('click', function () {
      section.scrollIntoView({ behavior: 'smooth' });
    });
  });

  field('cpf').addEventListener('input', function (event) {
    event.target.value = maskCpf(event.target.value);
    if (submitError.textContent === 'CPF inválido') submitError.hidden = true;
    refreshCpf();
    refreshSubmit();
  });

  field('whatsapp').addEventListener('input', function (event) {
    event.target.value = maskPhone(event.target.value);
    refreshSubmit();
  });

  field('cep').addEventListener('input', function (event) {
    event.target.value = maskCep(event.target.value);
    clearTimeout(cepTimer);
    if (digits(event.target.value).length === 8) {
      cepTimer = setTimeout(lookupCep, 300);
    } else {
      clearAddress();
      renderAddress('hidden');
    }
    refreshSubmit();
  });

  ['nome', 'email', 'numero', 'complemento', 'privacy'].forEach(function (name) {
    field(name).addEventListener('input', refreshSubmit);
    field(name).addEventListener('change', refreshSubmit);
  });

  field('privacy').addEventListener('change', function () {
    privacyFace.classList.toggle('is-checked', field('privacy').checked);
  });

  function postJson(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (response) {
      return readJson(response).then(function (body) {
        return { response: response, body: body || {} };
      });
    });
  }

  function campaignPayload(data, extra) {
    return Object.assign({}, data, { origem: 'expert-xp', campanha: 'expert-xp' }, extra);
  }

  function registerWithCoupon(data) {
    return postJson(CUPOM, { nome: data.nome.trim(), telefone: data.whatsapp, email: data.email.trim() }).then(function (result) {
      var body = result.body;
      if (result.response.status === 409) {
        throw new Error(body.error || body.message || 'Este e-mail já está cadastrado.');
      }
      if (!result.response.ok || body.vtexError || !body.codigo_cupom) {
        throw new Error(body.error || body.message || 'Erro ao gerar o cupom. Tente novamente.');
      }
      return postJson(WEBHOOK, campaignPayload(data, { codigo_cupom: body.codigo_cupom, cupom_criado: true })).catch(function () {
        return null;
      });
    });
  }

  function registerWithoutCoupon(data) {
    return postJson(WEBHOOK, campaignPayload(data, { codigo_cupom: '', cupom_criado: false })).then(function (result) {
      var body = result.body;
      if (result.response.status === 409) {
        throw new Error(body.message || body.error || 'Este e-mail já está cadastrado.');
      }
      if (!result.response.ok) {
        throw new Error(body.message || body.error || 'Erro ao enviar. Tente novamente.');
      }
    });
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (!FORM_AVAILABLE || !WEBHOOK || submitting) return;
    if (!field('privacy').checked) return;
    if (!isValidCpf(field('cpf').value)) {
      showError('CPF inválido');
      return;
    }
    if (!formValid()) return;
    var data = values();
    submitting = true;
    submitError.hidden = true;
    submitLabel.textContent = 'Enviando...';
    submitButton.classList.add('is-submitting');
    refreshSubmit();

    (CUPOM ? registerWithCoupon(data) : registerWithoutCoupon(data))
      .then(function () {
        showSuccess();
        scrollToSuccess();
      })
      .catch(function (error) {
        showError(error && error.message && !/fetch|network/i.test(error.message) ? error.message : 'Erro ao enviar. Tente novamente.');
      })
      .then(function () {
        submitting = false;
        submitLabel.textContent = 'Enviar';
        submitButton.classList.remove('is-submitting');
        refreshSubmit();
      });
  });

  if (new URLSearchParams(window.location.search).get('previewSuccess') === '1') showSuccess();

  var waves = root.querySelector('[data-expertxp-waves]');
  var wavesTarget = 0;
  var wavesCurrent = 0;
  var wavesFrame = null;

  function wavesTick() {
    wavesFrame = null;
    wavesCurrent += (wavesTarget - wavesCurrent) * 0.03;
    if (Math.abs(wavesTarget - wavesCurrent) <= 0.02) wavesCurrent = wavesTarget;
    waves.style.transform = 'translate3d(0, ' + wavesCurrent + 'px, 0)';
    if (wavesCurrent !== wavesTarget) wavesFrame = requestAnimationFrame(wavesTick);
  }

  function wavesScroll() {
    wavesTarget = window.scrollY * -0.05;
    if (wavesFrame === null) wavesFrame = requestAnimationFrame(wavesTick);
  }

  if (waves && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    window.addEventListener('scroll', wavesScroll, { passive: true });
    wavesScroll();
  }

  var videoBox = root.querySelector('[data-expertxp-video]');
  if (videoBox) {
    var video = videoBox.querySelector('video');
    var muteButton = videoBox.querySelector('[data-expertxp-mute]');
    var progress = videoBox.querySelector('[data-expertxp-progress]');
    var progressFill = videoBox.querySelector('[data-expertxp-progress-fill]');
    var dragging = false;

    var toggleMute = function (event) {
      event.stopPropagation();
      video.muted = !video.muted;
      muteButton.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
      muteButton.setAttribute('aria-label', video.muted ? 'Ativar som' : 'Desativar som');
    };

    var seek = function (event) {
      if (!video.duration) return;
      var rect = progress.getBoundingClientRect();
      var clientX = event.touches ? event.touches[0].clientX : event.clientX;
      var position = Math.min(Math.max((clientX - rect.left) / rect.width, 0), 1);
      video.currentTime = position * video.duration;
    };

    video.addEventListener('click', toggleMute);
    muteButton.addEventListener('click', toggleMute);
    video.addEventListener('timeupdate', function () {
      if (video.duration) progressFill.style.width = (video.currentTime / video.duration) * 100 + '%';
    });

    ['mousedown', 'touchstart'].forEach(function (name) {
      progress.addEventListener(name, function (event) {
        dragging = true;
        seek(event);
      }, { passive: true });
    });
    ['mousemove', 'touchmove'].forEach(function (name) {
      progress.addEventListener(name, function (event) {
        if (dragging) seek(event);
      }, { passive: true });
    });
    ['mouseup', 'mouseleave', 'touchend'].forEach(function (name) {
      progress.addEventListener(name, function () {
        dragging = false;
      });
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var playing = video.play();
            if (playing && playing.catch) playing.catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.3 }).observe(videoBox);
    }
  }

  refreshSubmit();
})();
